module.exports = __webpack_public_path__ + "img/园区@0.5x.76bec28e.png";